import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { MoveShowToPartnerGroupModalComponent } from '../../_modals/move-show-to-partner-group-modal/move-show-to-partner-group-modal.component';
import { PartnerGroup } from 'src/app/shared/models/partner-group';
import { AddShowsModalComponent } from '../../_modals/add-shows-modal/add-shows-modal.component';
import { PartnerGroupToolTipModalComponent } from '../../_modals/partner-group-tool-tip-modal/partner-group-tool-tip-modal.component';


@Component({
  selector: 'app-pro-partner-shows',
  templateUrl: './pro-partner-shows.component.html',
  styleUrls: ['./pro-partner-shows.component.scss']
})
export class ProPartnerShowsComponent implements OnInit, OnDestroy {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  dataSource: MatTableDataSource<any>;

  //table headers
  displayedColumns = ['show', 'seasons', 'partnerGroup', 'action']

  partnerId: number;

  //all partner groups the selected partner is a member of
  partnerGroups: PartnerGroup[];

  // every partner group, for names: a show's or an episode's group can be one this partner isn't in
  allPartnerGroups: PartnerGroup[] = [];

  // null shows every partner group (All Shows)
  private _selectedPartnerGroupId: number | null = null;
  get selectedPartnerGroupId() {
    return this._selectedPartnerGroupId;
  }
  set selectedPartnerGroupId(id: number | null) {
    if (id === this._selectedPartnerGroupId) {
      return;
    }
    this._selectedPartnerGroupId = id;
    this.loadShows();
  }

  partnerGroupsBtnDisplay: any[] = [];
  
  searchString: string;
  searchFilterFocused = false;

  private _showsRequest: Subscription;
  private _subscriptions: Subscription[] = [];

  constructor(private partnerService: PartnerService, private route: ActivatedRoute,
     private snackbarService: SnackBarService, public dialog: MatDialog) { }

  ngOnInit() {
    // the id comes from the details/:partnerId route, so it survives a reload and can't belong to a previous partner
    this._subscriptions.push(this.route.params.subscribe(params => {
      this.partnerId = Number(params['partnerId']);
      // another partner has other groups, so start again from All Shows
      this._selectedPartnerGroupId = null;
      this.loadShows();
    }));

    this._subscriptions.push(this.partnerService.getPartnerGroups().subscribe(groups => {
      this.allPartnerGroups = groups;
    }));

    //track partner groups for selected partner
    this._subscriptions.push(this.partnerService.partnerGroups$.subscribe((x) => {
      this.partnerGroups = x;

      //reset
      this.partnerGroupsBtnDisplay = [];

      //build display for group buttons
      this.partnerGroups.forEach(group => {

        let displayName = '';

        group.members.forEach(member => {
          displayName += member.partner.name + ' + ';
        });

        if (displayName.endsWith(' + ')) {
          //trim off last '+'
          displayName = displayName.slice(0, -3);
        }


        let displayValues = {
          id: group.id,
          name: displayName
        }

        this.partnerGroupsBtnDisplay.push(displayValues);
      })
    }));

  }

  ngOnDestroy() {
    if (this._showsRequest) {
      this._showsRequest.unsubscribe();
    }
    this._subscriptions.forEach(s => s.unsubscribe());
    this._subscriptions = [];
  }

  // get-partner-shows is the only source of rows; its seasons and episodes are the raw API objects
  loadShows() {
    if (this._showsRequest) {
      this._showsRequest.unsubscribe();
    }
    this._showsRequest = this.partnerService.getPROShowsByPartner(null, null, null, this.partnerId, this.selectedPartnerGroupId).subscribe((res: any) => {
      this.dataSource = new MatTableDataSource(res);
      // the column ids aren't row properties, so sort SHOW by title, SEASONS by how many there are and PARTNER GROUP
      // by the group's name
      this.dataSource.sortingDataAccessor = (show: any, column: string) => {
        if (column === 'show') {
          return show.title.toLowerCase();
        }
        if (column === 'seasons') {
          return show.seasons.length;
        }
        if (column === 'partnerGroup') {
          return this.getPartnerGroupName(show.partnerGroup_id).toLowerCase();
        }
        return show[column];
      };
      this.dataSource.sort = this.sort;
    });
  }

  trackById(_: number, item: { id: number }) {
    return item.id;
  }

  getPartnerGroupName(id: number | null) {
    const group = this.allPartnerGroups.find(g => g.id === id);
    return group ? group.name : '';
  }

  // an episode without a group of its own follows its show's group
  episodeHasOwnPartnerGroup(episode: any) {
    return episode.partnerGroup_id !== null && episode.partnerGroup_id !== undefined;
  }

  episodePartnerGroupName(show: any, episode: any) {
    return this.getPartnerGroupName(this.episodeHasOwnPartnerGroup(episode) ? episode.partnerGroup_id : show.partnerGroup_id);
  }


  // the modal closes with the updated show only when the move succeeded; then the current tab reloads
  moveShow(show: any) {
    this.dialog.open(MoveShowToPartnerGroupModalComponent, { data: { show: show }, width: '480px' })
      .afterClosed().subscribe((updatedShow: any) => {
        if (!updatedShow) {
          return;
        }
        this.snackbarService.showSnackBarMessage(`Moved ${show.title} to ${this.getPartnerGroupName(updatedShow.partnerGroup_id)}`, 'Close');
        this.loadShows();
      });
  }

    /**
   * Called when the drop down arrow is selected
   * Shows or hides show details
   * @param element 
   */
    toggleDetails(element: any) {

      element.expandDetails = !element.expandDetails;
  
    }

      /**
   * Used with ngClass to modify UI styling when a row's
   * expandedDetails are show
   * @param element 
   * @returns 
   */
  styleExpandedDetailsRow(element: any): boolean {

    //test hidden
    return element.expandDetails;
  }

  addShow() {
    const dialogRef = this.dialog.open(AddShowsModalComponent, {
      // width: '800px',
      // height: '400px',
      // data: { anyDataYouWantToPass: 'example' } // If you need to pass data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }


  showPartnerGroupToolTip(event: MouseEvent, buttonElement: HTMLElement, groupId: number): void {
    // the icon sits inside the group's button; opening its tooltip must not also select the group
    event.stopPropagation();

    let partnerGroup = this.partnerGroups.find(item => item.id === groupId);

    const rect = buttonElement.getBoundingClientRect();
    const buttonCenterX = rect.left; //point to the center of the button
    const buttonCenterY = rect.top + rect.height; //point to the bottom of the button

    const dialogRef = this.dialog.open(PartnerGroupToolTipModalComponent, {
      // data: { top: event.clientY, left: event.clientX }, //uses 'event: MouseEvent' argument
      // position: { top: `${event.clientY}px`, left: `${event.clientX}px` } //uses 'event: MouseEvent' argument
      data: { top: buttonCenterY, left: buttonCenterX, partnerGroup: partnerGroup },
      position: { top: `${buttonCenterY}px`, left: `${buttonCenterX}px` }
    });
  }

  getSeasonsCount(show: any) {
    return show.seasons.length;
  }

  getSearchVal(event: any){
    this.searchString = event.trim();
  }

  filterData(search: any) {
    this.dataSource.filter = search;
  }
}


